import { Box, Button, styled } from '@mui/material'
import React from 'react'

import { StyledLink } from './common'
import { authNavMap } from './definitions'
import { isPageActive } from './utils'

type Props = {
  currentPage: string
}

const DesktopNav: React.FC<Props> = ({ currentPage }) => (
  <Nav id="header-nav">
    <Box
      sx={{
        display: {
          xs: 'none',
          md: 'block',
        },
      }}
    >
      <NavList>
        {authNavMap.map((navItem) => (
          <li key={navItem.url}>
            <StyledLink id={`nav-${navItem.id}`} to={navItem.url} active={isPageActive(currentPage, navItem.pageGroup)}>
              <Button
                color="inherit"
                sx={{
                  paddingLeft: (theme) => theme.spacing(2),
                  paddingRight: (theme) => theme.spacing(2),
                }}
              >
                {navItem.title}
              </Button>
            </StyledLink>
          </li>
        ))}
      </NavList>
    </Box>
  </Nav>
)

const Nav = styled('nav')({
  display: 'flex',
  width: '100%',
  alignItems: 'center',

  '& ul': {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    alignItems: 'center',
    listStyleType: 'none',
    margin: 0,
    padding: '0 0 0 8px',
  },

  '& li a': {
    display: 'block',
  },

  '& li a button': {
    fontSize: '1rem',
  },
})

const NavList = styled('ul')({
  display: 'flex',
  flexWrap: 'wrap',
  width: '100%',
  alignItems: 'center',
  listStyleType: 'none',
  margin: 0,
  padding: '0 0 0 8px',
})

export default DesktopNav
